// Angular + External modules
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// BFX
import { PageNotFoundComponent } from "./not-found.component";
import { PageNotAuthorizedComponent } from "./not-authorized.component";

const errorRoutes: Routes = [
  { path: "not-found", component: PageNotFoundComponent },
  { path: "not-authorized", component: PageNotAuthorizedComponent },
];

@NgModule({
  imports: [RouterModule.forChild(errorRoutes)],
  exports: [RouterModule],
})
export class PageErrorRoutingModule {}
